import { useQuery } from '@tanstack/react-query';
import { api } from '../../services/api';
import type { StorageFile } from './types';

export interface ClientStorageListing {
  files: StorageFile[];
  /** Storage bucket the listing belongs to; submitted as `clientStorageBucketName`. */
  bucketName: string;
  matterId: string;
}

// GET /project/{id}/client-data returns the body directly (api.get does not unwrap):
// `bucket` and `foldersFiles` are top-level — not nested under `data`.
interface ClientDataResponse {
  bucket?: string;
  foldersFiles?: any[];
  accessIdMatterId?: string;
}

export function useClientStorageListing(projectId: string, baseDir: string, enabled: boolean) {
  return useQuery<ClientStorageListing>({
    queryKey: ['client-storage-listing', projectId, baseDir],
    queryFn: async () => {
      const qs = new URLSearchParams({ baseDir: encodeURI(baseDir) });
      const res = await api.get<ClientDataResponse>(`/project/${projectId}/client-data?${qs}`);
      const files = (res?.foldersFiles ?? []).map(f => {
        const path = f.path ?? f.relativePath ?? '';
        return {
          name: f.name ?? f.relativePath ?? path,
          path,
          isDirectory: typeof path === 'string' ? path.endsWith('/') : Boolean(f.isDirectory),
          size: f.byteSize ?? f.bytes,
        };
      });
      return { files, bucketName: res?.bucket ?? '', matterId: res?.accessIdMatterId ?? '' };
    },
    enabled: !!projectId && enabled,
    retry: false,
    staleTime: 0,
  });
}
